import React from 'react';
import { IMAGES } from '../mock';
import ServicePage from '../components/ServicePage';
import SEO, { serviceSchema } from '../components/SEO';

export default function Edelmetalle() {
  return (
    <>
      <SEO
        path="/edelmetalle"
        title="Edelmetalle – Vermögensaufbau mit Gold & Silber"
        description="Inflationsgeschützter Vermögensaufbau mit Edelmetallen. Antizyklischer Handel über weltweit führenden Partner. Physisches Gold, Silber und mehr."
        schema={serviceSchema({ name: 'Edelmetalle', description: 'Vermögensaufbau mit Gold, Silber und anderen Edelmetallen als Inflationsschutz.', url: '/edelmetalle' })}
      />
      <ServicePage
      excludeId="edelmetalle"
      kicker="Edelmetalle"
      title="Vermögensaufbau mit"
      titleAccent="Edelmetallen"
      hero={IMAGES.edelmetalle}
      lead="Warum Geld sparen, wenn täglich mehr davon gedruckt wird? Investiere in inflationsgeschützte und limitierte Güter wie Gold, Silber und andere Edelmetalle."
      bullets={[
        'Inflationsschutz seit Jahrhunderten bewährt',
        'Antizyklischer Handel für beste Konditionen',
        'Physische Werte, weltweit anerkannt',
        'Kooperation mit weltweit führendem Partner',
      ]}
      ctaPrimary={{ label: 'Mehr erfahren', href: '/kontakt', external: false }}
      body={[
        '<strong class="text-[#e8d5a8]">Warum Edelmetalle?</strong> Edelmetalle wie Gold und Silber haben sich über Jahrtausende als zuverlässige Wertspeicher bewährt. Sie bieten dir eine Absicherung gegen wirtschaftliche Unsicherheiten und geopolitische Risiken, da ihr Wert unabhängig von Schwankungen an den Finanzmärkten bleibt.',
        'Im Gegensatz zu Papiergeld, das beliebig vermehrt werden kann, sind Edelmetalle in ihrer Menge begrenzt und daher besonders wertbeständig. Zudem bieten sie dir die Möglichkeit, in <span class="text-[#e8d5a8]">physische Güter</span> zu investieren, die greifbar und weltweit anerkannt sind.',
        'Unser Kooperationspartner handelt Edelmetalle <span class="text-[#e8d5a8]">antizyklisch</span> – strategisch kaufen in Zeiten niedriger Preise, verkaufen, wenn Nachfrage und Preise hoch sind. Dieser bewährte Ansatz erzielt für dich stets die besten Konditionen und maximiert dein Investment langfristig.',
        'Nutze die Chance, dein Geld in sichere und wertbeständige Güter zu investieren. Schütze dich vor Inflation und wirtschaftlichen Unsicherheiten – mit unserer Unterstützung sicherst und vermehrst du dein Vermögen nachhaltig.',
      ]}
      />
    </>
  );
}
